/**
 * Mehlography Lab — Custom JS
 * Infinite Scroll using Shopify Sections Rendering API
 */
(function () {
  'use strict';
  if (window.mhlCustomScriptLoaded) return;
  window.mhlCustomScriptLoaded = true;

  function initInfiniteScroll() {
    var grid = document.getElementById('mhl-product-grid');
    var sentinel = document.getElementById('mhl-infinite-sentinel');
    var loading = document.getElementById('mhl-infinite-loading');

    if (!grid || !sentinel) return;

    var isFetching = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !isFetching) {
            var nextUrl = sentinel.dataset.nextUrl;
            if (!nextUrl) return;
            fetchNextPage(nextUrl);
          }
        });
      },
      { rootMargin: '200px' }
    );

    observer.observe(sentinel);

    function fetchNextPage(url) {
      isFetching = true;
      if (loading) loading.classList.add('is-visible');

      var sectionId = sentinel.dataset.sectionId || 'mhl_product_grid';
      var separator = url.indexOf('?') >= 0 ? '&' : '?';
      var sectionsUrl = url + separator + 'sections=' + sectionId;

      fetch(sectionsUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var sectionHtml = data[sectionId];
          if (!sectionHtml) throw new Error('Section not found: ' + sectionId);

          var parser = new DOMParser();
          var doc = parser.parseFromString(sectionHtml, 'text/html');

          var newItems = doc.querySelectorAll('.mhl-card-item');
          newItems.forEach(function (item) {
            grid.appendChild(item);
          });

          var newSentinel = doc.getElementById('mhl-infinite-sentinel');
          if (newSentinel && newSentinel.dataset.nextUrl) {
            sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
          } else {
            sentinel.dataset.nextUrl = '';
            observer.unobserve(sentinel);
          }
        })
        .catch(function (err) {
          console.error('[Mehlography] Infinite scroll error:', err);
        })
        .finally(function () {
          isFetching = false;
          if (loading) loading.classList.remove('is-visible');
        });
    }
  }

  function initHeaderHover() {
    if (window.innerWidth < 990) return;

    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details) return;

      menu.addEventListener('mouseenter', function () {
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function () {
        details.removeAttribute('open');
      });
    });
  }

  function initRecentlyViewed() {
    var STORAGE_KEY = 'mhl_recently_viewed';
    var MAX_ITEMS = 12;

    function getViewed() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    }

    function saveViewed(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {}
    }

    var productMeta = document.getElementById('mhl-product-meta');
    if (productMeta) {
      var currentProduct = {
        id: productMeta.dataset.productId,
        url: productMeta.dataset.productUrl,
        title: productMeta.dataset.productTitle,
        image: productMeta.dataset.productImage,
        price: productMeta.dataset.productPrice,
        available: productMeta.dataset.productAvailable === 'true',
        comingSoon: productMeta.dataset.productComingSoon === 'true',
        lowStock: productMeta.dataset.productLowStock === 'true'
      };

      var viewed = getViewed().filter(function (p) { return p.id !== currentProduct.id; });
      viewed.unshift(currentProduct);
      if (viewed.length > MAX_ITEMS) viewed = viewed.slice(0, MAX_ITEMS);
      saveViewed(viewed);
    }

    var section = document.getElementById('mhl-recently-viewed');
    var track = document.getElementById('mhl-recently-viewed-track');
    if (!section || !track) return;

    var viewed = getViewed();
    var currentId = productMeta ? productMeta.dataset.productId : null;
    var others = viewed.filter(function (p) { return p.id !== currentId; });
    if (others.length === 0) return;

    others.forEach(function (p) {
      var card = document.createElement('a');
      card.href = p.url;
      card.className = 'mhl-hscroll-card';
      var statusLabel = '';
      var badgeKind = '';
      if (p.comingSoon) {
        statusLabel = 'COMING SOON';
        badgeKind = 'coming-soon';
      } else if (!p.available) {
        statusLabel = 'SOLD OUT';
        badgeKind = 'sold-out';
      } else if (p.lowStock) {
        statusLabel = '残りわずか';
        badgeKind = 'low-stock';
      }
      var soldOut = statusLabel
        ? '<span class="mhl-badge mhl-badge--overlay mhl-badge--' + badgeKind + '">' + statusLabel + '</span>'
        : '';
      var imgHtml = p.image
        ? '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '';
      var priceHtml = badgeKind === 'low-stock' ? p.price : (statusLabel || p.price);
      card.innerHTML =
        '<div class="mhl-hscroll-card__media">' + imgHtml + soldOut + '</div>' +
        '<div class="mhl-hscroll-card__info">' +
          '<p class="mhl-hscroll-card__title">' + p.title + '</p>' +
          '<p class="mhl-hscroll-card__price">' + priceHtml + '</p>' +
        '</div>';
      track.appendChild(card);
    });

    section.style.display = '';
  }


  function initShareButtons() {
    document.querySelectorAll('.mhl-share-btn--save').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.url || window.location.href;
        copyToClipboard(url, btn, '保存しました');
      });
    });

    document.querySelectorAll('.mhl-share-btn--share').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.url || window.location.href;
        var title = btn.dataset.title || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else {
          copyToClipboard(url, btn, 'コピーしました');
        }
      });
    });
  }

  function copyToClipboard(text, btn, successMsg) {
    var origHTML = btn.innerHTML;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(function () {
        btn.textContent = successMsg;
        setTimeout(function () { btn.innerHTML = origHTML; }, 2000);
      });
    } else {
      var el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      btn.textContent = successMsg;
      setTimeout(function () { btn.innerHTML = origHTML; }, 2000);
    }
  }

  function initShippingModal() {
    var overlay = document.getElementById('mhl-shipping-overlay');
    var modal = document.getElementById('mhl-shipping-modal');
    if (!overlay || !modal) return;

    function openModal() {
      overlay.style.display = 'block';
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.style.display = 'none';
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-shipping-modal-trigger]').forEach(function (el) {
      el.addEventListener('click', openModal);
    });

    document.querySelectorAll('[data-shipping-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    modal.querySelectorAll('.mhl-stab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.querySelectorAll('.mhl-stab').forEach(function (t) {
          t.classList.remove('mhl-stab--active');
          t.style.borderBottomColor = 'transparent';
          t.style.fontWeight = '500';
          t.style.color = '#999';
        });
        document.getElementById('mhl-tab-domestic').style.display = 'none';
        document.getElementById('mhl-tab-overseas').style.display = 'none';
        btn.classList.add('mhl-stab--active');
        btn.style.borderBottomColor = '#000';
        btn.style.fontWeight = '700';
        btn.style.color = '#000';
        var tab = document.getElementById('mhl-tab-' + btn.dataset.tab);
        if (tab) tab.style.display = 'block';
      });
    });

  }

  function initPaymentModal() {
    var overlay = document.getElementById('mhl-payment-overlay');
    var modal = document.getElementById('mhl-payment-modal');
    if (!overlay || !modal) return;

    function openModal() {
      overlay.style.display = 'block';
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.style.display = 'none';
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-payment-modal-trigger]').forEach(function (el) {
      el.addEventListener('click', openModal);
    });

    document.querySelectorAll('[data-payment-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function initSnsCopy() {
    document.querySelectorAll('.mhl-sns-share__btn--copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.url || window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var orig = btn.textContent.trim();
            btn.textContent = 'コピーしました';
            setTimeout(function () { btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> URLをコピー'; }, 2000);
          });
        } else {
          var el = document.createElement('textarea');
          el.value = url;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          btn.textContent = 'コピーしました';
          setTimeout(function () { btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> URLをコピー'; }, 2000);
        }
      });
    });
  }

  function init() {
    initInfiniteScroll();
    initHeaderHover();
    initRecentlyViewed();
    initShippingModal();
    initPaymentModal();
    initSnsCopy();
    initShareButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
